<template>
  <component :is="currentComponent" 
    v-bind:editMode="this.editMode" 
    @load="Load"
    @getInfoPatient="InfoPatient"
    @getVisibleMenu="emitToGrandparent"
    ref="patient"
  >
  </component>
</template>

<script>
import Patient from "@/components/pages/patients/Patient";
import PatientUAE from "@/components/pages/patients/PatientUAE";
import DBFunctions from '@/common/DBFunctions.js'
import { mapState } from "vuex";

export default {
 props: ["editMode","HaveChanges"],
  name: "PatientSwitcher",
  mixins:[DBFunctions],
  computed: {
    ...mapState({       
      isUAE: state => state.companies.isUAE
    }),

    currentComponent() {       
      return this.isUAE ? PatientUAE : Patient;
    }
  },

  methods:{
    InfoPatient(Info){
      this.$emit('getInfoPatient', Info);
    },
    Load(isload){
       this.$emit('load', isload); 
    },
   emitToGrandparent(options) {
    this.$emit('getVisibleMenu', options);
    }
  },

  beforeRouteLeave(to, from, next) {
    if (!this.isReadOnly && this.$refs.patient.pendingChanges) {
      this.$bvModal.msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
            title: this.$tc('Shared.Patient'),
            okTitle: this.$t('Shared.BtnSave'),          
            cancelTitle: this.$t('Shared.BtnDismiss'),
            footerClass: 'p-2',
            titleClass: 'modal-title modal-type-warning',
            modalClass: 'not-draggable',
            headerClass: 'no-move-cursor',
            headerAttrs: {
                  style: 'cursor: default !important;'
              }
          })
            .then(async value => {
              if(!value){
                  /** Add for Fovorite button states */
                  this.checkExistFavorite('/app/patients');  
                  next();
              } else {
                // return;
                await this.$refs.patient.Save();
                if (this.$refs.patient.wasSaved) {
                  next();
                }
              }
            })		
    } else {
      next()
    }
  },
};
</script>